<template>
  <div id="pageRoot">
    <img id="bg" class="pageElement" src="/pages/img/sordocas/svgCas23bg.svg" />
    <img
      id="pencil"
      class="pageElement"
      src="/pages/img/sordoglo/svgGlo6Pencil.svg"
    />
    <img
      id="lines"
      class="pageElement"
      src="/pages/img/sordocas/svgCas23Lines.svg"
    />
    <img
      id="apple"
      class="pageElement basicItem01"
      src="/pages/img/sordocas/svgCas23Apple.svg"
    />
    <img
      id="chicken"
      class="pageElement basicItem01"
      src="/pages/img/sordocas/svgCas23Chicken.svg"
    />
    <img
      id="icecream"
      class="pageElement basicItem01"
      src="/pages/img/sordocas/svgCas23Icecream.svg"
    />

    <span class="normalTheme pageInstruction" style="left: 55px; top: 70px">
      <p>Escribe en orden las palabras para saber qué dice Zorrito.</p>
    </span>

    <span
      style="
        outline: 1px solid #a6a6a6;
        width: 337px;
        height: 220px;
        left: 570px;
        top: 485px;
        z-index: 2;
        position: absolute;
      "
    ></span>
    <saved-input-long
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      maxlength="250"
      style="line-height: 74px"
    />
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 0px;
  top: 196px;
}
#inputField01 {
  position: absolute;
  width: 330px;
  height: 220px;
  left: 570px;
  top: 485px;
  margin-left: 5px;
  margin-top: 0px;
  font-size: 33px;
  font-family: "Courier New", Courier, monospace;
  font-weight: bold;
  color: #2bb673;
  z-index: 10;
}
#pencil {
  position: absolute;
  left: 497px;
  top: 486px;
}
#lines {
  position: absolute;
  left: 581px;
  top: 539px;
}
#apple {
  position: absolute;
  left: 354px;
  top: 274px;
  z-index: 2;
}
#chicken {
  position: absolute;
  left: 544px;
  top: 241px;
  z-index: 2;
}
#icecream {
  position: absolute;
  left: 787px;
  top: 287px;
  z-index: 2;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["cas/Video 67.mp4", "cas/Video 83.mp4",],
    };
  },
};
</script>